"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InversifyCoreErrorKind = void 0;
var InversifyCoreErrorKind;
(function (InversifyCoreErrorKind) {
    InversifyCoreErrorKind[InversifyCoreErrorKind["injectionDecoratorConflict"] = 0] = "injectionDecoratorConflict";
    InversifyCoreErrorKind[InversifyCoreErrorKind["missingInjectionDecorator"] = 1] = "missingInjectionDecorator";
    InversifyCoreErrorKind[InversifyCoreErrorKind["planning"] = 2] = "planning";
    InversifyCoreErrorKind[InversifyCoreErrorKind["resolution"] = 3] = "resolution";
    InversifyCoreErrorKind[InversifyCoreErrorKind["unknown"] = 4] = "unknown";
})(InversifyCoreErrorKind || (exports.InversifyCoreErrorKind = InversifyCoreErrorKind = {}));
//# sourceMappingURL=InversifyCoreErrorKind.js.map